import { render, staticRenderFns } from "./infopa.vue?vue&type=template&id=10ee09fc&scoped=true&"
import script from "./infopa.vue?vue&type=script&lang=js&"
export * from "./infopa.vue?vue&type=script&lang=js&"
import style0 from "./infopa.vue?vue&type=style&index=0&id=10ee09fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ee09fc",
  null
  
)

export default component.exports